import OfferItems from '../OfferItems/offer-items';

export default OfferItems;